import { actions } from '@app/action/session';

import TermsAndConditions from '@module/terms-and-conditions';
import Privacy from '@module/privacy';

export default function(state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.ACCEPT_TERMS_CONDITIONS:
      return {
        ...state,
        tandc: TermsAndConditions.areAccepted(),
      };

    case actions.UPDATE_PRIVACY:
      return {
        ...state,
        privacy: {
          ...state.privacy,
          notified: Privacy.userHasClosedBanner(),
          allowTracking: Privacy.userAllowsTracking(),
        },
      };

    case actions.LANGUAGE_SET:
      return {
        ...state,
        language: action.language,
      };

    case actions.REDIRECT_SET:
      return {
        ...state,
        redirect: action.path,
      };

    case actions.REDIRECT_CLEAR:
      delete state['redirect'];
      return {
        ...state,
      };

    case actions.REQUIRE_REFRESH:
      return {
        ...state,
        incompatible_version: true,
      };

    case actions.SET_DOMAIN_USER_ID:
      return {
        ...state,
        domainUserId: action.id,
      };
  }

  return state;
}
